var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonComponent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: none;\n      }\n\n      .st2 {\n        fill: #828282;\n      }\n\n      .st3 {\n        isolation: isolate;\n      }\n\n      .st4 {\n        fill: #fff;\n      }\n\n      .st1 {\n        stroke: #707070;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_104811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_146226"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    width: 98,
    height: 102,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 0.5,
    y: 0.5,
    width: 97,
    height: 101,
    rx: 3.5,
    ry: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Two",
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.9,86v-7.1h2.4c.8,0,1.4.2,1.8.5s.6.8.6,1.4,0,.6-.3.9-.4.5-.8.6c.4.1.7.3.9.6.2.3.3.6.3,1,0,.7-.2,1.2-.6,1.5-.4.4-1,.5-1.8.5h-2.6ZM36.1,81.9h1.2c.4,0,.7,0,.9-.3.2-.2.3-.4.3-.7s0-.6-.3-.8-.5-.2-.9-.2h-1.2v2ZM36.1,82.8v2.2h1.4c.4,0,.7,0,.9-.3.2-.2.3-.5.3-.8,0-.7-.4-1.1-1.1-1.1h-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.3,85.5c-.3.4-.8.6-1.5.6s-1-.2-1.3-.5c-.3-.3-.4-.8-.4-1.5v-3.4h1.2v3.4c0,.7.3,1,.8,1s1-.2,1.2-.6v-3.8h1.2v5.3h-1.1v-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.1,79.4v1.3h.9v.9h-.9v2.9c0,.2,0,.3.1.4,0,0,.2.1.4.1s.3,0,.4,0v.9c-.3,0-.5.1-.8.1-.9,0-1.4-.5-1.4-1.5v-3h-.9v-.9h.9v-1.3h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.5,79.4v1.3h.9v.9h-.9v2.9c0,.2,0,.3.1.4,0,0,.2.1.4.1s.3,0,.4,0v.9c-.3,0-.5.1-.8.1-.9,0-1.4-.5-1.4-1.5v-3h-.9v-.9h.9v-1.3h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.9,83.3c0-.5.1-1,.3-1.4.2-.4.5-.7.9-1,.4-.2.8-.3,1.3-.3.7,0,1.3.2,1.7.7s.7,1.1.7,1.8v.3c0,.5,0,1-.3,1.4s-.5.7-.9,1c-.4.2-.8.3-1.3.3-.7,0-1.3-.2-1.8-.7-.4-.5-.7-1.2-.7-2h0ZM54.1,83.4c0,.5.1,1,.3,1.3.2.3.5.5.9.5s.7-.2.9-.5c.2-.3.3-.8.3-1.4s-.1-1-.3-1.3-.5-.5-.9-.5-.7.2-.9.5c-.2.3-.3.8-.3,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.9,80.7v.6c.4-.5.9-.7,1.6-.7,1.1,0,1.7.6,1.7,1.9v3.5h-1.2v-3.4c0-.3,0-.6-.2-.7-.1-.2-.4-.2-.7-.2-.5,0-.8.2-1.1.6v3.8h-1.2v-5.3h1.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "add_photo_alternate_black_24dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61965",
    className: "st0",
    d: "M22.1,10.6h54.3v54.3H22.1V10.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_79017"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146325",
    className: "st2",
    x: 26,
    y: 18,
    width: 47,
    height: 18,
    rx: 7,
    ry: 7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_146326"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 26,
    y: 39,
    width: 47,
    height: 18,
    rx: 7,
    ry: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 26.5,
    y: 39.5,
    width: 46,
    height: 17,
    rx: 6.5,
    ry: 6.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonComponent);
export default __webpack_public_path__ + "static/media/ButtonComponent.fa1715512cb089f220aced864b90f9fc.svg";
export { ForwardRef as ReactComponent };